var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cardContainer",style:({ borderLeftColor: _vm.borderColor })},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }